module.exports = __webpack_public_path__ + "img/p-5.3676e057.gif";